import { animated, useSpring } from "@react-spring/web";
import { clsx } from "clsx";

import { Button, type ButtonProps } from "./Button";

type AnimatedButtonProps = Pick<
  ButtonProps,
  "children" | "className" | "variant" | "size"
> & {
  className?: string;
  overlayClassName?: string;
  animationDuration?: number;
  onClick: () => void;
  disableAnimation?: boolean;
};

export const AnimatedButton = ({
  children,
  onClick,
  animationDuration = 1500,
  className,
  overlayClassName,
  size,
  disableAnimation = false,
  variant
}: AnimatedButtonProps) => {
  const animationProps = useSpring({
    from: { width: disableAnimation ? "100%" : "0%" },
    to: { width: "100%" },
    config: {
      duration: disableAnimation ? 0 : animationDuration,
      friction: 120,
      tension: 120
    },
    onRest: ({ finished }) => {
      if (finished && !disableAnimation) {
        onClick();
      }
    }
  });

  return (
    <Button
      className={clsx("relative overflow-hidden !px-32", className)}
      onClick={onClick}
      size={size}
      variant={variant}
    >
      <animated.div
        className={clsx("absolute inset-y-0 left-0 h-full", overlayClassName)}
        style={{ ...animationProps }}
      />
      {children}
    </Button>
  );
};
